/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { SetStateAction } from 'react';
import { Button, Icon } from '@blueprintjs/core';
import { ProgressBar as FormProgressBar } from './ProgressBar.js';
import { DatasetManagementContext } from '../datasetManagementContext';

import { ColorProps, DefinitionProps } from '../interfaces';

export const Complete: React.FC<CompleteProps> = ({ dil, colors, setStep }) => {
	const goBack = () => {
		setStep('Upload File');
		window.location.reload(false);
	};

	const { explorerCallback } = React.useContext(DatasetManagementContext);

	return (
		<div css={divCSS}>
			<FormProgressBar step={2} />
			<div css={ContainerCSS}>
				<Icon icon="tick" iconSize={33} intent="success" />
				<h2 css={{ color: colors.text }}>File '{(dil as DefinitionProps).name}' has been saved and uploaded.</h2>
				<p css={{ color: colors.text }}>
					Your file can be accessed from the dropdown menu for data source in the explorer.
				</p>
				<br />
				<Button onClick={goBack} intent="primary" outlined={true}>
					Done
				</Button>
				<br /> <br />
				<div
					css={{ display: 'inline', cursor: 'pointer', color: colors.text }}
					onClick={(e) => {
						e.preventDefault();
						return explorerCallback(dil);
					}}
				>
					View & Explore Data
				</div>
			</div>
		</div>
	);
};

const divCSS = css`
	margin: 0 auto;
	text-align: center;
`;

const ContainerCSS = css`
	padding-top: 25px;
`;

interface CompleteProps {
	dil: DefinitionProps | {};
	colors: ColorProps;
	setStep: React.Dispatch<SetStateAction<string>>;
}
